// extracted by mini-css-extract-plugin
module.exports = {"isVisuallyHidden":"Checkbox_isVisuallyHidden__fuLb6"};